module.exports = __webpack_public_path__ + "static/layouts-61c10ec392320b02c7b295cd704fac2d.png";